const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const TaskAnalyzerCommandUrl = {
    AnalyzeTask: Backofficebff + '/v1/task-analyzer/analyze',
    UpdateTask: Backofficebff + '/v1/task-analyzer/update-task',
};
